import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ShoppingDialogComponent } from 'src/app/commons/shopping-dialog/shopping-dialog.component';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
import { ProductCar } from 'src/app/models/productCar.model';
import { Plan } from 'src/app/models/plan.model';

@Component({
  selector: 'app-shopping-bar',
  templateUrl: './shopping-bar.component.html',
  styleUrls: ['./shopping-bar.component.scss']
})
export class ShoppingBarComponent implements OnInit {

  summary: number = 0;
  count: number = 0;
  planCounter: number = 0;
  planValue: number = 0;
  total: number = 0;

  constructor(
    private dialog: MatDialog,
    private store: Store<AppState>
    
    ) { }

  ngOnInit(): void {
    this.store.select('carPlanCheckout').subscribe(plan => {
      plan.forEach(item => {
        this.planCounter = 1;
        this.planValue = item.priceDiscount;
      });
      this.total = this.planValue + this.summary;
    });

    this.store.select('carCheckout').subscribe(product => {
      this.summary = 0;
      this.count = 0;
      product.forEach(item => {
        this.summary = this.summary + item.totalPrice;
        this.count = this.count + item.quantity;
      });
      this.total = this.planValue + this.summary;
    });

  }

  openShoppingDialog = (): void => {
    const shoppingConfig = new MatDialogConfig();
    shoppingConfig.panelClass = 'shopping-modal';
    shoppingConfig.backdropClass = 'shopping-backdrop';
    this.dialog.open(ShoppingDialogComponent, shoppingConfig);
  }

}
